import React from "react";
import { useBreakpoint } from "../../hooks/useBreakpoint";
import { useFilterExperiencesByLocationSlug } from "../../hooks/useFilterExperiencesByLocationSlug";

import { ConditionalSwiper } from "../../components/shared/conditionalSwiper";
import SimpleExperienceCard from "../../components/base/card/simpleExperienceCard";

const FocusGviExperiences = ({
  experiences,
  locationPageSlugs = [],
  genExperiencesSectionExperienceTitle,
  genExperiencesSectionExperienceSubtitle,
  genExperiencesSectionExperienceDescription,
  experiencesDetails = "",
  activitiesClass
}) => {
  const breakpoint = useBreakpoint();

  const experienceList = useFilterExperiencesByLocationSlug(locationPageSlugs);

  const expHeading =
    experiencesDetails?.gviExperiencesSectionHeading ??
    genExperiencesSectionExperienceTitle ??
    "Included in your program, <span> at no extra cost</span>";
  const expSubHeading =
    experiencesDetails?.gviExperiencesSectionSubheading ??
    genExperiencesSectionExperienceSubtitle ??
    "Make the most of our unique programs with these exclusively curated local adventure and wellness experiences.";
  const expTabSubtitle =
    experiencesDetails?.gviExperiencesTabSubtitle ??
    genExperiencesSectionExperienceDescription ??
    "Offered once a month, expand your adventure with GVI Experiences. These are just some of the activities offered on your program!";

  const gviActivities =
    experiences?.length > 0
      ? experiences
      : experienceList
          ?.map((experience) => {
            if (
              experience &&
              (experience?.experienceTitle ||
                experience?.genExperiencesSectionTitle) &&
              (experience?.experienceFeaturedImage?.sourceUrl ||
                experience?.genExperiencesSectionImage?.sourceUrl)
            ) {
              return {
                fallbackImg:
                  experience?.experienceFeaturedImage?.sourceUrl ??
                  experience?.genExperiencesSectionImage?.sourceUrl,
                title:
                  experience?.experienceTitle ??
                  experience?.genExperiencesSectionTitle
              };
            }
            return null;
          })
          .filter((it) => it) ?? [];
  return (
    <>
      {gviActivities && gviActivities.length > 0 && (
        <section className={activitiesClass}>
          <div className="container w-full md:w-4/5">
            <div className="text-left pb-6">
              <div className="gvi-experiences text-left">
                {expHeading && (
                  <div
                    className="heading font-lato text-black-lighter dark:text-white pb-2 font-light text-3xl leading-8 sm:leading-[38px]"
                    dangerouslySetInnerHTML={{ __html: expHeading }}
                  />
                )}
                {expSubHeading && (
                  <h3
                    className="!font-light"
                    dangerouslySetInnerHTML={{ __html: expSubHeading }}
                  />
                )}
              </div>
              {expTabSubtitle && (
                <div className="sub-heading text-xs text-black-lighter dark:text-gray-generic mt-7 pl-2 border-l-[2px] border-l-red-light dark:border-l-green-standard">
                  {expTabSubtitle}
                </div>
              )}
            </div>
            <section className="py-2">
              <div className="grid grid-cols-1 md:grid-cols-4 gap-x-2 gap-y-4">
                <ConditionalSwiper
                  condition={breakpoint === "xs"}
                  slidesPerView={1.25}
                  spaceBetween={10}
                  centeredSlides={false}
                  className="w-full h-full"
                >
                  {gviActivities &&
                    gviActivities.length > 0 &&
                    gviActivities.slice(0, 8).map((activity, idx) => {
                      return (
                        <div className="flex flex-col rounded-md" key={idx}>
                          <SimpleExperienceCard
                            experienceFeaturedImage={""}
                            experienceTitle={
                              activity?.title ??
                              activity.genExperiencesSectionTitle
                            }
                            fallbackImage={
                              activity?.fallbackImg ??
                              activity?.genExperiencesSectionImage?.sourceUrl
                            }
                            slim={true}
                          />
                        </div>
                      );
                    })}
                </ConditionalSwiper>
              </div>
            </section>
          </div>
        </section>
      )}
    </>
  );
};

export default FocusGviExperiences;
FocusGviExperiences.defaultProps = {
  activitiesClass:
    "flex flex-col items-center justify-center bg-yellow-lighter dark:bg-gray-darkest px-4 sm:px-0 py-12 sm:py-16"
};
